import React from "react";
export function Footer() {
  return <footer className="bg-ink px-5 pt-12 pb-32 sm:pb-28 text-center" data-id="element-37" data-mp="32wmqrybuniwl">
      <div className="mx-auto max-w-3xl" data-id="element-38" data-mp="3ggar7wn6mf5z">
        <p className="font-serif text-xl font-bold text-white" data-id="element-39" data-mp="3ghc4m7ro7dqv">Otoplasty Clinical Pathway System™</p>
        <p className="mt-2 text-sm text-white/60" data-id="element-40" data-mp="32lrn9grlb3lk">© 2026 · Dr. Michael Carter · All rights reserved.</p>
        <p className="mt-6 text-xs leading-relaxed text-white/50" data-id="element-41" data-mp="36n3cvmagrotr">
          Educational material intended for qualified medical professionals. This product is designed to support professional learning and
          case-based study. It is not a substitute for formal surgical training, supervised practice, current clinical evidence,
          institutional protocols, individualized patient evaluation, or professional clinical judgment. Surgical techniques, indications,
          and outcomes vary. Healthcare professionals are responsible for applying appropriate clinical judgment and following applicable
          professional requirements.
        </p>
      </div>
    </footer>;
}